<template>
  <div ref="dasmap" class="google-map" :class="{full: isFull}"></div>
</template>

<script>
import mapStyles from "./mapStyle";
import { setTimeout, setInterval } from "timers";
export default {
  name: "google-map",
  props: ["name", "isFull", "mapData"],
  data: function() {
    return {
      mapName: this.name + "-map",
      markerCoordinates: [
        {
          latitude: -25.784211,
          longitude: 28.266294
        },
        {
          latitude: -26.044311,
          longitude: 28.097728
        },
        {
          latitude: -31.208894,
          longitude: 24.226914
        }
      ],
      map: null,
      markers: []
    };
  },

  watch: {
    mapData() {
      this.updateMarkersFromMapData();
    }
  },

  methods: {
    updateMarkersFromMapData(data) {
      data = data || this.mapData;
      if (!data || !data.map) return;
      this.updateMarkers(
        data.map(d => ({
          latitude: d.latr,
          longitude: d.longr
        }))
      );
    },
    updateMarkers(markers) {
      // console.log("updating data", markers);
      this.markers.forEach(marker => {
        marker.setMap(null);
      });
      this.markers = [];

      if (markers.length == 0) return;
      this.markerCoordinates = markers;

      let bounds = new google.maps.LatLngBounds();
      this.markerCoordinates.forEach(coord => {
        const position = new google.maps.LatLng(
          coord.latitude,
          coord.longitude
        );
        const marker = new google.maps.Marker({
          position,
          map: this.map
        });
        this.markers.push(marker);
        bounds.extend(position);
      });
      this.map.fitBounds(bounds);

      let zoom = this.map.getZoom();
      this.map.setZoom(zoom > 10 ? 10 : zoom);
    }
  },

  mounted: function() {
    const element = this.$refs.dasmap;
    const options = {
      center: new google.maps.LatLng(0, 0),
      styles: mapStyles,
      disableDefaultUI: true,
      backgroundColor: "#111",
      zoom: 0
    };

    this.map = new google.maps.Map(element, options);
    if (this.mapData && this.mapData.length > 0) {
      // console.log("===== mapdata set!");
      this.updateMarkersFromMapData();
    } else {
      // console.log("===== no mapdata set!");
      // this.updateMarkers(this.markerCoordinates)
    }
  }
};
</script>

<style scoped>
.google-map {
  width: 100%;
  height: 160px;
  margin: 0 auto;
  background: #000;
}
.google-map.full {
  height: 560px;
}
</style>